import { useCallback } from "react";
import { useFrame } from "react-frame-component";
import { GoogleFont } from "../../../MaterialTripList/MailVisualEditor/objects/googleFont";

type Callback = (font: GoogleFont) => void

export function useLoadFont(): Callback {
    const frame = useFrame();
    const _document = frame?.document ?? document

    return useCallback((font) => {
        const styleElement = _document.head.querySelector(`link[id="${font.name}-font"]`);
        if (!styleElement) {
            const link = _document.createElement('link');
            link.id = font.name + '-font';
            link.rel = 'stylesheet';
            link.href = font.url;
            _document.head.appendChild(link);
        }
    }, [_document]);
}